import React from 'react';
import Spinner from '../../Assets/Spinner.svg';

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)', // Optional background overlay
        zIndex: 9999, // Ensure it appears above other elements
      }}
    >
      <img src={Spinner} alt="Loading..." style={{ width: '50px', height: '50px' }} />
    </div>
  );
};

export default Loader;
